var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.92287 16.8457C4.55415 16.8457 1 13.2916 1 8.92287C1 4.55415 4.55415 1 8.92287 1C13.2916 1 16.8457 4.55415 16.8457 8.92287C16.8457 13.2916 13.2916 16.8457 8.92287 16.8457ZM8.92287 1.76596C4.97658 1.76596 1.76596 4.97658 1.76596 8.92287C1.76596 12.8692 4.97658 16.0798 8.92287 16.0798C12.8692 16.0798 16.0798 12.8692 16.0798 8.92287C16.0798 4.97658 12.8692 1.76596 8.92287 1.76596Z",
    fill: "#19191D",
    stroke: "#19191D",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.617 19C18.519 19 18.421 18.9626 18.3462 18.8878L14.0377 14.5793C13.8881 14.4297 13.8881 14.1873 14.0377 14.0377C14.1873 13.8881 14.4297 13.8881 14.5793 14.0377L18.8878 18.3462C19.0374 18.4958 19.0374 18.7382 18.8878 18.8878C18.813 18.9626 18.715 19 18.617 19Z",
    fill: "#19191D",
    stroke: "#19191D",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.47f1b4a9ebeda25e31fd5ea067e7351a.svg";
export { ForwardRef as ReactComponent };